import { render, staticRenderFns } from "./Excerpt.vue?vue&type=template&id=617be270&scoped=true&"
import script from "./Excerpt.vue?vue&type=script&lang=js&"
export * from "./Excerpt.vue?vue&type=script&lang=js&"
import style0 from "./Excerpt.vue?vue&type=style&index=0&id=617be270&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617be270",
  null
  
)

export default component.exports